var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.video.isLoaded)?_c('span',{attrs:{"id":"video-timestamp"}},[_vm._v(_vm._s(_vm.video.currentTime)+" / "+_vm._s(_vm.video.duration))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }